import { createReducer, on } from '@ngrx/store';

import * as PayRollActions from './pay-roll.actions';
import { initialPayRollState, PayRollState } from './pay-roll.state';

const payRollReducer = createReducer<PayRollState>(
  initialPayRollState,
  on(PayRollActions.fetchPayRollBatches, (state) => ({
    ...state,
    fetchedAt: null,
  })),
  on(PayRollActions.fetchCurrentPayRollBatchById, (state) => ({
    ...state,
    fetchedAt: null,
  })),
  on(PayRollActions.fetchCurrentPayRollById, (state) => ({
    ...state,
    fetchedAt: null,
  })),
  on(PayRollActions.uploadPayRollBatch, (state) => ({
    ...state,
    fetchedAt: null,
  })),
  on(PayRollActions.processPayRollBatch, (state) => ({
    ...state,
    fetchedAt: null,
  })),
  on(PayRollActions.uploadPayRollBatchSuccess, (state, { message }) => ({
    ...state,
    message,
    fetchedAt: new Date(),
  })),
  on(PayRollActions.processPayRollBatchSuccess, (state, { message }) => ({
    ...state,
    message,
    fetchedAt: new Date(),
  })),
  on(
    PayRollActions.fetchPayRollBatchesSuccess,
    (state, { payRollBatches }) => ({
      ...state,
      payRollBatches,
      fetchedAt: new Date(),
    })
  ),
  on(
    PayRollActions.fetchCurrentPayRollBatchByIdSuccess,
    (state, { payRollBatch }) => ({
      ...state,
      currentPayRollBatch: payRollBatch,
      fetchedAt: new Date(),
    })
  ),
  on(PayRollActions.fetchCurrentPayRollByIdSuccess, (state, { payRoll }) => ({
    ...state,
    currentPayRoll: payRoll,
    fetchedAt: new Date(),
  }))
);

export { payRollReducer };
